export const STANDARD_CARD_STR = '普通';
export const REQUEST_TYPE_CRED = 'CREDENTIAL';
export const REQUEST_TYPE_CERT = 'CREDENTIAL';
export const FIRST_REQUEST = 'CARD_REQUEST';
export const CARD_TYPE_PLASTIC = '实体卡';
export const CARD_TYPE_E = '电子卡';

export const getCardOptions = (cardOptions) =>
  cardOptions
    .filter(
      (o) => !(o.ecardType === REQUEST_TYPE_CRED && o.styleName.indexOf(STANDARD_CARD_STR) >= 0)
    )
    .reduce((res, cur) => {
      if (!res.find((o) => o.styleName === cur.styleName)) {
        // 默认展示蓝色标准卡面
        if (cur.styleName.indexOf(STANDARD_CARD_STR) >= 0 && res.length > 0) {
          cur.imageUrl = 'https://img.yzcdn.cn/upload_files/2020/04/15/Fjjy-dI_w1MsK6U8PLO_3TNppFgB.jpg'
        }
        res.push(cur);
      }
      return res;
    }, []);

export const getMinPriceOptions = (cardOptions) => {
  let obj = {}
  getCardOptions(cardOptions).forEach(item => {
    if (obj[item.styleName]) {
      obj[item.styleName].push(item)
    } else {
      obj[item.styleName] = [item]
    }
  })
  let arr2 = []
  for (let k in obj) {
    obj[k].sort((a, b) => {
      return a.price - b.price
    })
    arr2.push(obj[k][0])
  }
  return arr2
}

export const getCardOptionNames = (cardOptions) =>
  getCardOptions(cardOptions)
    .map((o) => o.styleName)

export const getPostage = (skus) => {
  skus = skus.filter(s => s.typeName === CARD_TYPE_PLASTIC);
  if (skus.length > 0) {
    if (skus.find(s => s.price > 1)) {
      return 0;
    }
    return 2000;
  } else {
    return 0;
  }
}
